"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var VerticalTab_1 = __importDefault(require("../VerticalTab"));
var styles_1 = require("./styles");
var react_i18next_1 = require("react-i18next");
var colors_1 = require("../ThemeProvider/colors");
var MobileMultipleBanks = function (_a) {
    var banks = _a.banks, codes = _a.codes, handleNavigation = _a.handleNavigation, identifier = _a.identifier;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(VerticalTab_1.default, { "data-testid": "multiple-banks-menu-button", label: t('prism-header:store'), key: identifier + '-multiple-banks' },
        banks &&
            banks.map(function (_a) {
                var url = _a.url, primary = _a.primary, secondary = _a.secondary;
                return (react_1.default.createElement(material_1.ListItem, { "data-testid": "multiple-banks-menu-".concat(primary), key: primary, className: "fs-unmask", component: "a", sx: styles_1.ListItemStyle, href: url, onClick: handleNavigation(url) },
                    react_1.default.createElement(material_1.ListItemText, { primary: primary }),
                    react_1.default.createElement(styles_1.SecondaryListItemText, { primary: secondary })));
            }),
        codes && codes.length > 0 && (react_1.default.createElement(VerticalTab_1.default, { "data-testid": "access-codes", label: t('prism-header:access-codes'), key: identifier + '-access-codes' }, codes.map(function (_a) {
            var url = _a.url, primary = _a.primary, secondary = _a.secondary;
            return (react_1.default.createElement(material_1.ListItem, { "data-testid": "multiple-banks-menu-".concat(primary), key: primary, className: "fs-unmask", component: "a", sx: styles_1.AccessCodeStyle, href: url, onClick: handleNavigation(url) },
                react_1.default.createElement(material_1.ListItemText, { primary: primary }),
                react_1.default.createElement(styles_1.SecondaryListItemText, { primary: secondary, primaryTypographyProps: {
                        fontSize: '12px',
                        color: colors_1.tannerGray['600'],
                    } })));
        })))));
};
exports.default = MobileMultipleBanks;
//# sourceMappingURL=MobileMultipleBanks.js.map